export default __webpack_public_path__ + "static/aios-fff2dd25ce3a709b98b5bfce425a08cf.png";